import { createContext } from 'react';

type AppName = 'userconsole' | 'adminconsole';

export type ConfigEnv =
  | 'dev'
  | 'qa'
  | 'staging'
  | 'govcloud-moderate'
  | 'govcloud-staging'
  | 'production';

export type ConfigContextType = {
  launchDarklyId: string;
  fullStoryOrgId: string;
  apmUrl: string;
  appUrl: string;
  appName: AppName;
  autoOpsUrl: string;
  autoOpsAdminUrl: string;
  env: ConfigEnv;
  isWebhookConnectorEnabled: boolean;
  /** Hard switch for the AutoOps Cloud assistant UI. */
  isCloudAssistantEnabled: boolean;
};

export const ConfigContext = createContext<ConfigContextType | null>(null);
